var map = {
	"./Cardiology.png": 66469,
	"./Chiropractic.png": 37703,
	"./Dentist.png": 51167,
	"./Dermatalogy.png": 50047,
	"./Gynecology.png": 84366,
	"./Neurology.png": 85724,
	"./Ophthalmology.png": 82969,
	"./Orthopedic.png": 21405,
	"./Otology.png": 88841,
	"./Pediatric.png": 53109,
	"./Psychiatry.png": 69210,
	"./Pulmonology.png": 81359,
	"./Rhinology.png": 60095,
	"./default-speciality1.png": 61490,
	"./default_speciality3.png": 7074,
	"./pt-dashboard-01.png": 85031,
	"./pt-dashboard-02.png": 66028,
	"./pt-dashboard-03.png": 18293,
	"./pt-dashboard-04.png": 78170,
	"./specialities-02.png": 56692
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 24935;